import i18n from '@shared/config/i18n';

const { t } = i18n;

export const getStatusName = (status: string) => {
  switch (status) {
    case 'waiting-for-payment':
      return t('PaymentExpectation');
    case 'price-clarification':
      return t('PriceClarification');
    case 'paid':
      return t('PaymentPaid');
    default:
      return '';
  }
};
